/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Closed_Tag1Inputs */

const en_coinvestments_tracking_closed_tag1 = /** @type {(inputs: Coinvestments_Tracking_Closed_Tag1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Coinvestments_Tracking_Closed_Tag1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_closed_tag1 = /** @type {((inputs?: Coinvestments_Tracking_Closed_Tag1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Closed_Tag1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_closed_tag1(inputs)
});
export { coinvestments_tracking_closed_tag1 as "coInvestments_tracking_closed_tag" }